<template>
    <div>
        <el-container>
            <el-aside width="300px">
                <side-bar></side-bar>
            </el-aside>

            <el-container class="container">
                <el-header style="margin-bottom: 25px">
                    <nav-bar></nav-bar>
                </el-header>

                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>

        <el-footer>
            <footer-bar></footer-bar>
        </el-footer>
    </div>
</template>

<script>
    import NavBar from "../../../components/NavBar";
    import SideBar from "../../../components/SideBar";
    import FooterBar from "../../../components/FooterBar";

    // noinspection JSUnusedGlobalSymbols
    export default {
        name: 'MaMain',
        components: {FooterBar, SideBar, NavBar},
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .el-footer {
        position: relative;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 0px;
        margin-top: 105px;
    }

    @media screen and (max-width: 1300px) {
        .footer {
            position: relative;
            right: 0;
            bottom: 0;
            left: 0;
            text-align: center;
        }
    }
</style>
